import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Cookie } from "lucide-react";

const LOGO_URL = "/logo.png";

export default function CookieSzabalyzat() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#0A0F1C] text-white">
      {/* Header */}
      <header className="border-b border-white/10 bg-[#0A0F1C]/95 backdrop-blur sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="PálffyVill" className="h-12 w-auto" />
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm text-[#94A3B8] hover:text-white transition-colors">
            <ArrowLeft className="w-4 h-4" />Vissza a főoldalra
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 bg-[#FF5722]/20 rounded-xl flex items-center justify-center">
            <Cookie className="w-6 h-6 text-[#FF5722]" />
          </div>
          <div>
            <p className="text-sm text-[#FF5722] font-bold uppercase tracking-wider">palfy-vill.hu</p>
            <h1 className="text-3xl font-bold font-['Outfit']">Cookie (süti) szabályzat</h1>
          </div>
        </div>

        <p className="text-sm text-[#94A3B8] mb-12 border-l-2 border-[#FF5722] pl-4">Hatálybalépés dátuma: 2026. április 16.</p>

        <p className="text-sm text-[#CBD5E1] leading-relaxed mb-10">Jelen szabályzat a palfy-vill.hu weboldalon alkalmazott sütikre vonatkozik. A weboldal használatával Ön elfogadja a jelen szabályzat rendelkezéseit.</p>

        <div className="legal-content space-y-10">
          {/* 1 */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">1. Mik azok a sütik (cookie-k)?</h2>
            <p className="text-sm text-[#CBD5E1] leading-relaxed">A cookie-k kisméretű adatfájlok, amelyeket a weboldal küld a böngészőnek. Segítik a weboldal működését, javítják a felhasználói élményt, és lehetővé teszik a felhasználói viselkedés elemzését, valamint a releváns hirdetések megjelenítését.</p>
          </section>

          {/* 2 */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">2. Hogyan működnek a cookie-k?</h2>
            <p className="text-sm text-[#CBD5E1] leading-relaxed">A rendszer egy egyedi azonosítót hoz létre, amelyet a böngésző eltárol. Visszatéréskor a böngésző elküldi ezt az azonosítót. Így működik például: bejelentkezési állapot megjegyzése, űrlapértékek tárolása, konverziók mérése, remarketing-hirdetések, személyre szabott tartalom.</p>
          </section>

          {/* 3 */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">3. A weboldalon használt sütik céljai</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-sm">
              {["Weboldal működése", "Felhasználói élmény", "Statisztikai mérések", "Teljesítménymérés", "Hirdetések", "Kampánykövetés"].map((cel) => (
                <div key={cel} className="bg-[#121A2F] border border-white/5 rounded-lg p-3 text-center text-[#94A3B8]">{cel}</div>
              ))}
            </div>
          </section>

          {/* 4 */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">4. A sütik típusai</h2>

            <h3 className="text-base font-semibold mb-3 text-[#FF5722]">4.1 Alapműködést biztosító sütik</h3>
            <p className="text-sm text-[#94A3B8] mb-6">Session sütik, értesítési üzenetek állapota, bejelentkezési adatok, sütibeállítások, anonimizált Analytics sütik.</p>

            <h3 className="text-base font-semibold mb-3 text-[#FF5722]">4.2 Statisztikai és teljesítménymérő sütik</h3>
            <p className="text-sm text-[#94A3B8] mb-6">Google Analytics, Google Optimize – a felhasználói viselkedést elemzik, személyes azonosítás nélkül.</p>

            <h3 className="text-base font-semibold mb-3 text-[#FF5722]">4.3 Célzó- és hirdetési sütik</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
              {[
                ["Google Ads", "https://www.google.com/intl/hu/policies/privacy"],
                ["Facebook (Meta)", "https://www.facebook.com/help/cookies/"],
                ["Instagram", "https://help.instagram.com/402411646841720"],
                ["TikTok Pixel", "https://www.tiktok.com/legal/page/us/privacy-policy/en"],
                ["Google Analytics", "https://www.google.com/intl/hu/policies/privacy"],
                ["Google Tag Manager", "https://www.google.com/intl/hu/policies/privacy"],
                ["ActiveCampaign", "https://www.activecampaign.com/legal/privacy-policy"],
                ["Microsoft Clarity", "https://clarity.microsoft.com/privacy"],
                ["GoHighLevel", "https://www.gohighlevel.com/privacy-policy"],
              ].map(([name, url]) => (
                <div key={name} className="bg-[#121A2F] border border-white/5 rounded-lg p-3 flex items-center justify-between text-sm">
                  <span>{name}</span>
                  <a href={url} target="_blank" rel="noreferrer" className="text-[#3B82F6] hover:underline text-xs">Tájékoztató</a>
                </div>
              ))}
            </div>

            <h3 className="text-base font-semibold mb-3 text-[#FF5722]">4.4 GoHighLevel sütik</h3>
            <p className="text-sm text-[#94A3B8]">Kampány- és funnelkövetés, űrlapadatok, automatizált e-mail/SMS indítás.</p>
          </section>

          {/* 5 */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">5. A sütik kezelése és kikapcsolása</h2>
            <p className="text-sm text-[#CBD5E1] leading-relaxed">A felhasználó a böngészőjében bármikor módosíthatja vagy törölheti a sütiket. A tiltás csökkentheti a weboldal működését.</p>
          </section>

          {/* 6 */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">6. Böngésző süti beállítások</h2>
            <div className="space-y-2">
              {[
                ["Google Chrome", "https://support.google.com/chrome/answer/95647"],
                ["Mozilla Firefox", "https://support.mozilla.org/hu/kb/sutik-engedelyezese-es-tiltasa"],
                ["Microsoft Edge", "https://support.microsoft.com/en-us/microsoft-edge/view-cookies-in-microsoft-edge-a7d95376-f2cd-8e4a-25dc-1de753474879"],
                ["Safari (Mac)", "https://support.apple.com/hu-hu/guide/safari/sfri11471/mac"],
              ].map(([name, url]) => (
                <a key={name} href={url} target="_blank" rel="noreferrer" className="flex items-center justify-between bg-[#121A2F] border border-white/5 rounded-lg p-4 hover:border-[#3B82F6]/30 transition-colors text-sm">
                  <span>{name}</span>
                  <span className="text-[#3B82F6] text-xs">Beállítások</span>
                </a>
              ))}
            </div>
          </section>

          {/* 7 */}
          <section>
            <h2 className="text-xl font-bold font-['Outfit'] text-[#3B82F6] mb-4">7. Jogszabályi háttér</h2>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2003. évi C. törvény</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2001. évi CVIII. törvény</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2011. évi CXII. törvény</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>2002/58/EK irányelv</li>
              <li className="flex gap-2"><span className="text-[#FF5722]">-</span>GDPR (EU 2016/679 rendelet)</li>
            </ul>
          </section>
        </div>
      </main>
    </div>
  );
}
